import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Actions',
        defaultMessage: 'Actions'
    },
    ActionsMobile: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Actions Mobile',
        defaultMessage: 'Actions'
    },
    AddBusinessActivity: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Add Business Activity',
        defaultMessage: 'Add Business Activity'
    },
    AddBusinessActivityPopupTitle: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Add a business activity',
        defaultMessage: 'Add a business activity'
    },
    EditBusinessActivityPopupTitle: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Edit a business activity',
        defaultMessage: 'Edit a business activity'
    },
    BusinessActivityPopupSubtitle: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Enter your business activity details',
        defaultMessage: 'Enter your business activity details'
    },
    BusinessActivityHeader: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Business activity',
        defaultMessage: 'Business activity'
    },
    NameOfBusiness: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Name of Business',
        defaultMessage: 'Name of Business'
    },
    NameOfBusinessMobile: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Name of Business Mobile',
        defaultMessage: 'Name of Business:'
    },
    CoverageType: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Coverage Type',
        defaultMessage: 'Coverage Type'
    },
    CoverageTypeMobile: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Coverage Type Mobile',
        defaultMessage: 'Coverage Type:'
    },
    BusinessActivityAdded: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Business activity item has been added.',
        defaultMessage: 'Business activity <strong>{item}</strong> has been added.'
    },
    BusinessActivityRemoved: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.Business activity item has been removed.',
        defaultMessage: 'Business activity <strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    BusinessActivityParagraph: {
        id: 'quoteandbind.pup.views.pup-bizdetails-exposures.no information exists',
        defaultMessage: 'No Information Exists'
    }
});
